import { mapGetters } from 'vuex'
import moment from 'moment'
import 'moment-timezone'
import timeHelper from '../utils/time'

export default {
  data () {
    return {
      daysLength: 4, // Change the value for longer pickup/delivery timing options.
      logisticType: ''
    }
  },
  computed: {
    ...mapGetters(['currentTime', 'storeInfo', 'timezone']),
    timeInterval () {
      return this.logisticType === 'delivery' ? 45 : 15
    },
    timeOptions () {
      if (this.currentTime && this.timezone) {
        moment.tz.setDefault(this.timezone)
        let momentObj = null
        if (this.isAcceptTime) {
          momentObj = this.order.requested_at > this.currentTime ? moment.unix(this.order.requested_at) : moment.unix(this.currentTime)
        } else {
          momentObj = moment.unix(this.currentTime)
        }
        let i = -1
        let options = []
        // We prepare the timings array day by day.
        // We loop here for each day starting from today and get the timing lists.
        while (i < this.daysLength) {
          if (i > 0) {
            options.push(...this.getTimesForDay(momentObj.clone().add(i, 'days').startOf('day')))
          } else if (i < 0) {
            options.push(...this.getTimesForDay(momentObj.clone().add(i, 'days'), momentObj.clone()))
          } else {
            options.push(...this.getTimesForDay(momentObj.clone()))
          }
          i++
        }
        // Eliminating any duplicate time (in case store days timings overlapped)
        options = options.filter((item, index, self) => index === self.findIndex(item2 => item2.text === item.text))
        return options
      }
      return []
    }
  },
  methods: {
    getTimesForDay (momentObjPointer, momentObjCurrent = null) {
      const timeArray = []
      if (!this.storeInfo) {
        return []
      }
      // This function prepares the timing list for the given day.
      const storeDayRange = timeHelper.getTimeRange(this.storeInfo.schedule[momentObjPointer.format('dddd').toLowerCase()], momentObjPointer)
      
      // If store day timing is invalid or store is closed, we skip adding timings for that day.
      if (!storeDayRange) {
        return []
      }
      let asapTime = null
      const pointer = momentObjCurrent ? momentObjCurrent : momentObjPointer
      if (pointer.isAfter(storeDayRange.startTime)) {
        if (pointer.clone().add(15, 'minutes').isAfter(storeDayRange.endTime)) {
          // If current time is greater than store start and end time, we skip the day as the store is already closed.
          return []
        }
        // If current time is between store start and end time then set start time as current time.
        storeDayRange.startTime = pointer.clone()
        asapTime = {
          text: 'ASAP (' + storeDayRange.startTime.format('dddd HH:mm') + ')',
          value: storeDayRange.startTime.clone().unix(),
          asap: true
        }
        timeArray.push(asapTime)
      }
        storeDayRange.startTime.add(this.timeInterval, 'minutes')
      // Rounding off to upcoming quater
      if (storeDayRange.startTime.minutes() % 15 !== 0) {
        storeDayRange.startTime.add(15 - (storeDayRange.startTime.minutes() % 15), 'minutes')
      }
      if (!asapTime || asapTime.value !== storeDayRange.startTime.clone().unix() && storeDayRange.startTime.isBefore(storeDayRange.endTime)) {
        timeArray.push({
          text: storeDayRange.startTime.format('dddd HH:mm'),
          value: storeDayRange.startTime.clone().unix()
        })
      }
      // Adding times for the given day.
      while (storeDayRange.startTime.isBefore(storeDayRange.endTime)) {
        storeDayRange.startTime.add(15, 'minutes')
        timeArray.push({
          text: storeDayRange.startTime.format('dddd HH:mm'),
          value: storeDayRange.startTime.clone().unix()
        })
      }
      return timeArray
    }
  }
}
